import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_023.jpg';
page.images = [
  {
    imageId: 'page023_zoom0',
    rectangle: {
      x: 113,
      y: 1898,
      width: 1515,
      height: 569,
    },
    imageSrc: 'images/page023/023 5.jpg',
  },
  {
    imageId: 'page023_zoom1',
    rectangle: {
      x: 1327,
      y: 1155,
      width: 430,
      height: 545,
    },
    imageSrc: 'images/page023/023 4.jpg',
  },
  {
    imageId: 'page023_zoom2',
    rectangle: {
      x: 612,
      y: 1150,
      width: 687,
      height: 553,
    },
    imageSrc: 'images/page023/023 3.jpg',
  },
  {
    imageId: 'page023_zoom3',
    rectangle: {
      x: 152,
      y: 1157,
      width: 425,
      height: 538,
    },
    imageSrc: 'images/page023/023 2.jpg',
  },
  {
    imageId: 'page023_zoom4',
    rectangle: {
      x: 222,
      y: 132,
      width: 1410,
      height: 783,
    },
    imageSrc: 'images/page023/023 1.jpg',
  },
];
export default page;
